import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import Api from '@app/services/api';

interface IProps {
  catalog_uid: string;
  product_uid: string;
}

export const useDeleteProductQuery = () => {
  const client = useQueryClient();
  const catalogsT = useTranslation(NSKeys.catalogs);

  return useMutation({
    mutationFn: async ({ catalog_uid, product_uid }: IProps) => {
      await Api.products.deleteProductFromCatalog(catalog_uid, product_uid);
      await client.invalidateQueries(['getCatalogProducts']);
      await client.invalidateQueries(['getCatalogProductsTable']);
    },
    onSuccess: async () => {
      message.open({
        type: 'success',
        content: catalogsT.t('form.toastEditSuccess'),
      });
    },
    onError: () => {
      message.open({
        type: 'error',
        content: catalogsT.t('errors.putError'),
      });
    },
  });
};
